module.exports = __webpack_public_path__ + "static/media/abedu-logo.c9cbdb8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/iit/abedu-logo.png
// module id = 447
// module chunks = 1 3